module.exports = __webpack_public_path__ + "static/girl-d6e63aeed005c86ef338e8e0497038f4.jpg";